import { each } from "lodash";
import dayjs from "lib/dayjs";
import { subscriptionsAPI } from "services/apis.service";
import { isNotNullOrEmpty } from "utils/string.util";

export class HomeschoolService {
  #axios;

  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async postHomeschoolApplicationData(data, referralCode) {
    try {
      // return new Promise((resolve) => resolve({
      //   success: true,
      //   data: this.#convertDataToFormData(data),
      //   errors: []
      // }));
      const response = await this.#axios.post(
        subscriptionsAPI.CreateGuardianAndStudents,
        this.#convertDataToFormData(data, referralCode),
        { cache: false }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  #convertDataToFormData(data, referralCode) {
    // const { students, ...otherData } = data;
    // const formData = {
    //   students: [],
    //   ...otherData,
    // };

    // each(students, (student) => {
    //   const { email, letterOfIntent, gradeLevel, ...otherData } = student;
    //   const convertedFileData = new FormData();
    //   convertedFileData.append("file", letterOfIntent[0], letterOfIntent[0].name);
    //   formData.students.push({
    //     email: isNotNullOrEmpty(email) ? email : undefined,
    //     letterOfIntent: convertedFileData.get("file"),
    //     graduationYear: this.#convertToGraduationYear(gradeLevel),
    //     ...otherData,
    //   });
    // });
    const formData = new FormData();
    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
    formData.append("streetAddress", data.streetAddress);
    formData.append("city", data.city);
    formData.append("state", data.state);
    formData.append("zipCode", data.zipCode);
    formData.append("country", data.country);
    formData.append("email", data.email);
    formData.append("localSchoolDistrict", data.localSchoolDistrict);
    formData.append("isDataCollectionAgreementAccepted", true);
    if (referralCode) {
      formData.append("referralCode", referralCode);
    }
    each(data.students, (student, index) => {
      formData.append(`students[${index}].firstName`, student.firstName);
      formData.append(`students[${index}].lastName`, student.lastName);
      formData.append(
        `students[${index}].graduationYear`,
        this.#convertToGraduationYear(student.gradeLevel)
      );
      if (isNotNullOrEmpty(student.email)) {
        formData.append(`students[${index}].email`, student.email);
      }
      formData.append(
        `students[${index}].letterOfIntent`,
        student.letterOfIntent[0],
        student.letterOfIntent[0].name
      );
    });
    return formData;
  }

  #convertToGraduationYear(gradeLevel) {
    const currentMonth = dayjs().month();
    const yearsToAdd = currentMonth > 5 ? gradeLevel + 1 : gradeLevel;
    return dayjs().add(yearsToAdd, "year").year();
  }
}
